import { trackError } from 'helpers/track_error';
import type { AccountantLeadPayload } from '../components/types';

export function trackPartnerSurveySignupSubmitFailed(
  accountantLead: AccountantLeadPayload,
  status: string,
  responseText: string
) {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AccountantLeadCreationEvent',
    data: {
      eventType: 'submit',
      result: 'failure',
      location: 'Partner Signup v2',
      accountantLead,
      failureStatus: status,
      failureReason: responseText,
    },
  });

  trackError({
    error: new Error(`[PartnerSurveySignup] Failed with status ${status}`),
    custom: {
      message: responseText,
    },
  });
}

export function trackPartnerSurveySignupSubmitSuccess() {
  GustoAnalytics.track({
    eventCategory: window.SNOWPLOW_EVENT_CATEGORIES.VISITOR_EVENT,
    eventName: 'AccountantLeadCreationEvent',
    data: {
      eventType: 'submit',
      result: 'success',
      location: 'Partner Signup v2',
    },
  });
}
